import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const scales = [49, 99];

const getPercentageColor = percentage => {
  if (percentage <= scales[0]) {
    return "#ffaa55"; // Orange
  }
  if (percentage <= scales[1]) {
    return "#9ca8b1"; // Gray
  }
  return "#3d64ff"; // Green
};

const MatchPercentageWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.isModal ? "20px" : "6px")};
  .percentage {
    font-size: ${props => (props.isModal ? "24px" : "18px")};
    line-height: 1;
  }
  .subtitle {
    font-size: ${props => (props.isModal ? "10px" : "9px")};
    font-weight: 600;
    overflow-wrap: anywhere;
  }
`;

function MatchPercentage({ score, isModal }) {
  const { t } = useTranslation(["global"]);

  if (typeof score !== "number") return null;

  const percentage = Math.floor(Math.min(score, 1) * 100);

  return (
    <MatchPercentageWrapper isModal={isModal} data-test="match-percentage">
      <span
        className="percentage"
        style={{ color: getPercentageColor(percentage) }}
      >
        {percentage}%
      </span>
      <span className="subtitle">{t("global:match")}</span>
    </MatchPercentageWrapper>
  );
}

export default MatchPercentage;
